import { ReactComponent as Activity } from '../../../assets/icons/Activity.svg';
import { ReactComponent as AddressCard } from '../../../assets/icons/AddressCard.svg';
import { ReactComponent as AngleLeft } from '../../../assets/icons/AngleLeft.svg';
import { ReactComponent as AngleLeftDouble } from '../../../assets/icons/AngleLeftDouble.svg';
import { ReactComponent as AnyMatch } from '../../../assets/icons/AnyMatch.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/ArrowDown.svg';
import { ReactComponent as ArrowLeftBig } from '../../../assets/icons/ArrowLeftBig.svg';
import { ReactComponent as Attach } from '../../../assets/icons/Attach.svg';
import { ReactComponent as BarsStaggered } from '../../../assets/icons/BarsStaggered.svg';
import { ReactComponent as Bell } from '../../../assets/icons/Bell.svg';
import { ReactComponent as BellEmpty } from '../../../assets/icons/BellEmpty.svg';
import { ReactComponent as Board } from '../../../assets/icons/Board.svg';
import { ReactComponent as Calendar } from '../../../assets/icons/Calendar.svg';
import { ReactComponent as Check } from '../../../assets/icons/Check.svg';
import { ReactComponent as CircleQuestion } from '../../../assets/icons/CircleQuestion.svg';
import { ReactComponent as Close } from '../../../assets/icons/Close.svg';
import { ReactComponent as Comment } from '../../../assets/icons/Comment.svg';
import { ReactComponent as Copy } from '../../../assets/icons/Copy.svg';
import { ReactComponent as Duplicate } from '../../../assets/icons/Duplicate.svg';
import { ReactComponent as EllipsisVertical } from '../../../assets/icons/EllipsisVertical.svg';
import { ReactComponent as Envelope } from '../../../assets/icons/Envelope.svg';
import { ReactComponent as Eye } from '../../../assets/icons/Eye.svg';
import { ReactComponent as EyeSlash } from '../../../assets/icons/EyeSlash.svg';
import { ReactComponent as Facebook } from '../../../assets/icons/Facebook.svg';
import { ReactComponent as FillDrip } from '../../../assets/icons/FillDrip.svg';
import { ReactComponent as FullScreen } from '../../../assets/icons/FullScreen.svg';
import { ReactComponent as GitHub } from '../../../assets/icons/GitHub.svg';
import { ReactComponent as Google } from '../../../assets/icons/Google.svg';
import { ReactComponent as Hide } from '../../../assets/icons/Hide.svg';
import { ReactComponent as Image } from '../../../assets/icons/Image.svg';
import { ReactComponent as Info } from '../../../assets/icons/Info.svg';
import { ReactComponent as Key } from '../../../assets/icons/Key.svg';
import { ReactComponent as Label } from '../../../assets/icons/Label.svg';
import { ReactComponent as Labels } from '../../../assets/icons/Labels.svg';
import { ReactComponent as Link } from '../../../assets/icons/Link.svg';
import { ReactComponent as Linkedin } from '../../../assets/icons/Linkedin.svg';
import { ReactComponent as List } from '../../../assets/icons/List.svg';
import { ReactComponent as MatchCase } from '../../../assets/icons/MatchCase.svg';
import { ReactComponent as Microsoft } from '../../../assets/icons/Microsoft.svg';
import { ReactComponent as Minus } from '../../../assets/icons/Minus.svg';
import { ReactComponent as MoveUpDown } from '../../../assets/icons/MoveUpDown.svg';
import { ReactComponent as NoConnection } from '../../../assets/icons/NoConnection.svg';
import { ReactComponent as Pause } from '../../../assets/icons/Pause.svg';
import { ReactComponent as Pencil } from '../../../assets/icons/Pencil.svg';
import { ReactComponent as Play } from '../../../assets/icons/Play.svg';
import { ReactComponent as Plus } from '../../../assets/icons/Plus.svg';
import { ReactComponent as PlusMath } from '../../../assets/icons/PlusMath.svg';
import { ReactComponent as ProjectSettings } from '../../../assets/icons/ProjectSettings.svg';
import { ReactComponent as Reset } from '../../../assets/icons/Reset.svg';
import { ReactComponent as Server } from '../../../assets/icons/Server.svg';
import { ReactComponent as Settings } from '../../../assets/icons/Settings.svg';
import { ReactComponent as Show } from '../../../assets/icons/Show.svg';
import { ReactComponent as Sliders } from '../../../assets/icons/Sliders.svg';
import { ReactComponent as SortArrowUp } from '../../../assets/icons/SortArrowUp.svg';
import { ReactComponent as Star } from '../../../assets/icons/Star.svg';
import { ReactComponent as StarHalf } from '../../../assets/icons/StarHalf.svg';
import { ReactComponent as StarOutline } from '../../../assets/icons/StarOutline.svg';
import { ReactComponent as Switch } from '../../../assets/icons/Switch.svg';
import { ReactComponent as Trash } from '../../../assets/icons/Trash.svg';
import { ReactComponent as Trello } from '../../../assets/icons/Trello.svg';
import { ReactComponent as TriangleDown } from '../../../assets/icons/TriangleDown.svg';
import { ReactComponent as User } from '../../../assets/icons/User.svg';
import { ReactComponent as UserAdd } from '../../../assets/icons/UserAdd.svg';
import { ReactComponent as Users } from '../../../assets/icons/Users.svg';
import { ReactComponent as WindowMaximize } from '../../../assets/icons/WindowMaximize.svg';
import { ReactComponent as X } from '../../../assets/icons/X.svg';
import { ReactComponent as Youtube } from '../../../assets/icons/Youtube.svg';

const IconType = {
  Activity,
  AddressCard,
  AngleLeft,
  AngleLeftDouble,
  AnyMatch,
  ArrowDown,
  ArrowLeftBig,
  Attach,
  BarsStaggered,
  Bell,
  BellEmpty,
  Board,
  Calendar,
  Check,
  CircleQuestion,
  Close,
  Comment,
  Copy,
  Duplicate,
  EllipsisVertical,
  Envelope,
  Eye,
  EyeSlash,
  Facebook,
  FillDrip,
  FullScreen,
  GitHub,
  Google,
  Hide,
  Image,
  Info,
  Key,
  Label,
  Labels,
  Link,
  Linkedin,
  List,
  MatchCase,
  Microsoft,
  Minus,
  MoveUpDown,
  NoConnection,
  Pause,
  Pencil,
  Play,
  Plus,
  PlusMath,
  ProjectSettings,
  Reset,
  Server,
  Settings,
  Show,
  Sliders,
  SortArrowUp,
  Star,
  StarHalf,
  StarOutline,
  Switch,
  Trash,
  Trello,
  TriangleDown,
  User,
  UserAdd,
  Users,
  WindowMaximize,
  X,
  Youtube,
};

export default IconType;
